module.exports = __webpack_public_path__ + "img/pr-6.67176636.png";